import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from "primereact/inputnumber";
import {
  getValidacionReporte,
  actualizarTemporalReporte,
  confirmarDocumentoReporte,
} from "../../../../service/AffariService";

export const ValidarDocumentoDialog = ({
  visible,
  documento,
  tipo,
  toast,
  onCancel,
  onCompleted,
}) => {
  const [detalles, setDetalles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible || !documento?.id) return;
    let mounted = true;
    setLoading(true);
    getValidacionReporte(documento.id)
      .then((response) => {
        if (mounted) setDetalles(response?.detalles || []);
      })
      .catch(() => {
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: "No fue posible cargar las cantidades del documento",
        });
      })
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, [visible, documento?.id, toast]);

  const updateCantidad = (id, value) => {
    const cantidad = Math.max(0, Number(value || 0));
    setDetalles((current) =>
      current.map((item) =>
        item.id === id
          ? {
              ...item,
              confirmado: cantidad,
              pendiente: Math.max(Number(item.cantidad || 0) - cantidad, 0),
              total: Number(item.valorUnitario || 0) * cantidad,
            }
          : item,
      ),
    );
  };

  const confirmar = async () => {
    if (!detalles.some((item) => Number(item.confirmado || 0) > 0)) {
      toast?.current?.show({
        severity: "warn",
        summary: "Validación",
        detail: "Debe confirmar una cantidad mayor a 0 en al menos un producto",
      });
      return;
    }

    try {
      setLoading(true);
      for (const detalle of detalles) {
        await actualizarTemporalReporte(
          documento.id,
          detalle.id,
          Number(detalle.confirmado || 0),
        );
      }
      const response = await confirmarDocumentoReporte(documento.id, tipo);
      toast?.current?.show({
        severity: "success",
        summary: "Éxito",
        detail: response?.mensaje || "Documento confirmado correctamente",
      });
      if (onCompleted) await onCompleted(response);
    } catch (error) {
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "No fue posible confirmar el documento",
      });
    } finally {
      setLoading(false);
    }
  };

  const footer = (
    <div>
      <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={onCancel} disabled={loading} />
      <Button label="Finalizar" icon="pi pi-check" onClick={confirmar} loading={loading} />
    </div>
  );

  return (
    <Dialog
      header={`${tipo === "BLOQUEADA" ? "Validar cotización bloqueada" : "Confirmar nota de venta"}${documento?.folio ? ` - ${documento.folio}` : ""}`}
      visible={visible}
      onHide={onCancel}
      footer={footer}
      style={{ width: "72rem", maxWidth: "95vw" }}
      modal
    >
      <p className="mt-0 text-600">
        Ingrese la cantidad que será confirmada. La diferencia permanecerá pendiente.
      </p>
      <DataTable
        value={detalles}
        loading={loading}
        responsiveLayout="scroll"
        emptyMessage="Sin productos"
        tableStyle={{ minWidth: "58rem" }}
      >
        <Column field="codigo" header="Código" style={{ width: "9rem" }} />
        <Column field="glosa" header="Producto" />
        <Column field="cantidad" header="Solicitado" style={{ width: "8rem" }} />
        <Column
          header="Confirmado"
          body={(row) => (
            <InputNumber
              value={Number(row.confirmado || 0)}
              min={0}
              max={Number(row.cantidad || 0)}
              minFractionDigits={0}
              maxFractionDigits={3}
              onValueChange={(e) => updateCantidad(row.id, e.value)}
              className="w-full"
              inputClassName="w-full text-right"
            />
          )}
          style={{ width: "12rem" }}
        />
        <Column
          field="pendiente"
          header="Pendiente"
          style={{ width: "8rem" }}
          bodyStyle={{ textAlign: "right" }}
        />
      </DataTable>
    </Dialog>
  );
};
